import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const CustomTooltip = ({
  id,
  children,
  tooltip,
  placement = 'right',
  trigger = ['hover', 'focus'],
  maxWidth,
  style,
}) => {
  return (
    <OverlayTrigger
      overlay={
        <Tooltip
          id={id}
          style={{
            background: '#FFFFFF',
            boxShadow: '0px 0px 30px 0px #00000029',
            transform: 'translate(0, 0)',
            borderRadius: 4,
            border: 'none',
            marginLeft: 10,
            padding: 16,
            display: 'block',
            textAlign: 'start',
            zIndex: '2020',
            maxWidth,
            ...style,
          }}
        >
          {tooltip}
        </Tooltip>
      }
      placement={placement}
      trigger={trigger}
      delayShow={300}
      delayHide={150}
    >
      {children}
    </OverlayTrigger>
  );
};

export default CustomTooltip;
